import { LocaleService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { AR_SA } from './ar-sa.js';
import { DE_DE } from './de-de.js';
import { EN_GB } from './en-gb.js';
import { EN_US } from './en-us.js';
import { ES_AR } from './es-ar.js';
import { ES_CO } from './es-co.js';
import { ES_MX } from './es-mx.js';
import { PT_BR } from './pt-br.js';
const NUMERIC_LOCALES = [
    AR_SA,
    DE_DE,
    EN_GB,
    EN_US,
    ES_AR,
    ES_CO,
    ES_MX,
    PT_BR,
];
function getNumericLocale() {
    const locale = LocaleService.getCurrentLocale();
    if (locale) {
        for (const numericLocale of NUMERIC_LOCALES) {
            if (numericLocale.ID.toLowerCase() === locale.toLowerCase()) {
                return numericLocale;
            }
        }
    }
    return EN_US;
}
function getNumericLocales() {
    return NUMERIC_LOCALES;
}
export * from './types.js';
export { getNumericLocale, getNumericLocales, };
//# sourceMappingURL=utils.js.map